<script>
  import { onMount } from "svelte";
  import { makeWebsiteRequest } from "../Common/tools";

  import NewList from "./NewList.svelte";
  import {External, M} from "../external";

  export let data, onChangeType;

  export function get() {
    return data;
  }

  let type = "single";
  let lists = [];

  let change = (e) => {
    type = e.currentTarget.value;
    onChangeType(type);
  };

  let createList = () => {
    const buttons = [
      External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
        let formData = popup.component().get();

        External.Tools.makeWebsiteRequest({
          action: "setMarketingLists",
          data: {
            isNew: true,
            data: JSON.stringify(formData)
          },
          onOk: function (response) {
            lists = response.data || [];
            popup.close();
          }
        });
      }),
      External.Button.MIDDLE_CLOSE
    ];

    External.Tools.showWindow({
      isModal: false,
      title: M.NEW_LIST,
      width: 500,
      buttons: buttons,
      action: {
        onShow: function (popup, context) {
          popup.bindComponent(
            new NewList({
              target: popup.getContentArea(),
              props: {
                data: {}
              }
            })
          );
        }
      }
    });
  };

  $: {
    if (!data.name) data.name = "";
    if (!data.email) data.email = "";
  }

  onMount(async () => {
    let response = await makeWebsiteRequest({
      action: "getMarketingLists"
    });
    lists = response.data || [];
  });
</script>

<div class="popup-widget-wrapper">
  <div class="f-left col20">
    <div class="popup-input-wrapper">
      <div class="radio-option">
        <input type="radio" name="type" id="singleSubCbx" value="single" class="css-checkbox" on:change={change} checked="checked" />
        <label for="singleSubCbx" class="css-label">{M.SINGLE_SUBSCRIBER}</label>
      </div>
      <div class="radio-option mt-15 mb-15">
        <input type="radio" name="type" id="importSubsCbx" value="import" class="css-checkbox" on:change={change} />
        <label for="importSubsCbx" class="css-label">{M.IMPORT}</label>
      </div>
    </div>
    {#if type === "single"}
      <div class="popup-input-wrapper">
        <h5 class="f-15">{M.NAME}</h5>
        <span class="light-gray-text">{M.SUBSCRIBER_NAME}</span>
        <input type="text" bind:value={data.name} />
      </div>
      <div class="popup-input-wrapper">
        <h5 class="f-15">{M.EMAIL}</h5>
        <span class="light-gray-text">{M.SUBSCRIBER_EMAIL}</span>
        <input type="text" bind:value={data.email} />
      </div>
    {/if}
    <div class="popup-input-wrapper">
      <h5 class="f-15">{M.LIST}</h5>
      <span class="light-gray-text">{M.CHOOSE_SUBSCRIBER_LIST}</span>
      <select bind:value={data.list}>
        <option value="">{M.SELECT_LIST}</option>
        {#each lists as list (list)}
          <option value={list.id}>{list.name}</option>
        {/each}
      </select>
      <div class="f-right"><a class="blue-text" on:click={createList}>{M.CREATE_LIST}</a></div>
    </div>
  </div>
</div>
